import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/spec_attr_component/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},

        {text: 'Attribute group', value: 'attribute_group', sortable: true, filterable: true, divider: true},
        {text: 'Attribute name', value: 'attribute_name', sortable: true, filterable: true, divider: true},
        {text: 'Component', value: 'component_display', sortable: false, filterable: true, divider: true},
        {text: 'Units name', value: 'units_name', sortable: false, filterable: true, divider: true},
        {text: 'Units', value: 'units', sortable: false, filterable: true, divider: true},
        {text: 'units_symbol', value: 'units_symbol', sortable: false, filterable: true, divider: true},
        {text: 'Value', value: 'value', sortable: false, filterable: true, divider: true},
        {text: 'Display value', value: 'display_value', sortable: false, filterable: true, divider: true},
        {text: 'Value type', value: 'value_type', sortable: false, filterable: true, divider: true},
        // {text: 'SI value', value: 'si_value', sortable: false, filterable: true, divider: true},
        {text: 'Value integer', value: 'value_integer', sortable: false, filterable: true, divider: true},
        {text: 'Value float', value: 'value_float', sortable: false, filterable: true, divider: true},
        {text: 'Value text', value: 'value_text', sortable: false, filterable: true, divider: true},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['units_name'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        SpecAttrComponentTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}